import * as React from "react";
import loaderGif from "../../assets/animations/logo-loader.gif";

const SIZE = 100;

export const LoaderClock = ({ size = SIZE }: { size?: number }) => {
  return <img src={loaderGif} style={{ width: size, height: size }} />;
};
